import { render, staticRenderFns } from "./EventDurationComponent.vue?vue&type=template&id=5cebbe0a&scoped=true&"
import script from "./EventDurationComponent.vue?vue&type=script&lang=js&"
export * from "./EventDurationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cebbe0a",
  null
  
)

export default component.exports